import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import Checkbox, { type CheckboxProps } from '../../../Form/Checkbox';
import type { HookInputBaseProps } from '../../types';

export interface HookCheckboxProps<T extends FieldValues = FieldValues> extends CheckboxProps, HookInputBaseProps<T> {
  name: FieldPath<T>;
}

export const HookCheckbox = <T extends FieldValues>(props: HookCheckboxProps<T>) => {
  const { name, required, validate, id, formMethods, ...rest } = props;
  const idOrName = id || name;
  const { control } = useFormContext<T>();

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={formMethods?.control || control}
      render={({ field, fieldState: { error } }) => (
        <>
          <Checkbox {...rest} {...field} id={idOrName} checked={field.value} error={error?.message} />
        </>
      )}
    />
  );
};
